import WOW from 'wow.js'

const wowInstance = new WOW(
  {
    boxClass: 'wow',
    animateClass: 'animate__animated',
    mobile: true,
    offset: 200
  }
)

export default function wow () {
  wowInstance.init()
}
